import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function RMASystemSection() {
  const phases = [{
    icon: '👁️',
    num: '1',
    title: 'Detección de Radar',
    subtitle: 'Hacer visible lo invisible',
    desc: 'Identificamos el momento exacto en que tu punto ciego toma el control de tus decisiones financieras.'
  }, {
    icon: '✂️',
    num: '2',
    title: 'Extracción Quirúrgica',
    subtitle: 'Interrupción de patrones',
    desc: 'Aniquilamos la carga emocional de tus traumas financieros: deudas heredadas, quiebras pasadas, miedo al juicio.'
  }, {
    icon: '⚡',
    num: '3',
    title: 'Instalación de Frecuencia',
    subtitle: 'El nuevo estado natural',
    desc: 'Tu sistema nervioso acepta la abundancia como estado natural. No "buscas" el dinero — tu identidad lo atrae.'
  }];
  const results = [{
    icon: '🧲',
    text: 'Tu comunicación se vuelve magnética'
  }, {
    icon: '👑',
    text: 'Tu liderazgo se vuelve incuestionable'
  }, {
    icon: '💰',
    text: 'El dinero llega desde lugares inesperados'
  }, {
    icon: '🔓',
    text: 'Tu termostato finalmente permite que entre'
  }];
  return <section className="py-16 md:py-[80px] px-4 bg-[#050505] border-y border-border" data-id="element-290">
      <div className="max-w-[1000px] mx-auto" data-id="element-291">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-292">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-gold uppercase" data-id="element-293">
            <span className="inline-block h-[2px] w-5 bg-gold" data-id="element-294"></span>
            El Mecanismo Único
          </div>
          <h2 className="mb-4 font-heading text-3xl md:text-[40px] font-black leading-[1.1] text-white uppercase tracking-tight" data-id="element-295">
            AQUÍ ES DONDE <span className="text-gold" data-id="element-296">TODO CAMBIA</span>
          </h2>
          <p className="text-[14px] leading-[1.7] text-text-secondary max-w-[600px]" data-id="element-297">
            El <strong className="text-white" data-id="element-298">Sistema RMA</strong> no es
            psicología tradicional ni motivación barata. Es el colapso de tu
            vieja identidad a través de neuro-asociación y frecuencia
            vibratoria.
          </p>
        </motion.div>

        {/* Surgery quote */}
        <motion.div className="mb-10 rounded-r-lg border border-border border-l-[3px] border-l-gold bg-surface-dark px-[22px] py-[18px]" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} data-id="element-299">
          <p className="text-[18px] md:text-[22px] font-black italic leading-[1.3] text-white" data-id="element-300">
            "No te estoy ofreciendo un libro de consejos.{' '}
            <span className="text-gold" data-id="element-301">Te estoy ofreciendo una cirugía.</span>"
          </p>
        </motion.div>

        {/* 3 Phase Cards */}
        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-302">
          {phases.map((phase, index) => <motion.div key={index} variants={cardVariants} className="overflow-hidden rounded-lg border border-border bg-surface transition-colors hover:border-gold" data-id="element-303">
              <div className="flex items-center gap-2 border-b border-border bg-surface-light px-[16px] py-2.5" data-id="element-304">
                <div className="flex h-[18px] w-[18px] items-center justify-center rounded-full bg-gold text-[10px] font-black text-black" data-id="element-305">
                  {phase.num}
                </div>
                <div className="font-heading text-[9px] font-bold tracking-[2px] text-gold uppercase" data-id="element-306">
                  Fase {phase.num}
                </div>
              </div>
              <div className="px-[16px] py-[16px]" data-id="element-307">
                <div className="mb-1 text-[24px]" data-id="element-308">{phase.icon}</div>
                <div className="mb-1 font-heading text-[13px] font-black uppercase tracking-[0.5px] text-white" data-id="element-309">
                  {phase.title}
                </div>
                <div className="mb-3 text-[10px] font-bold tracking-[1px] text-gold uppercase" data-id="element-310">
                  {phase.subtitle}
                </div>
                <div className="text-[13px] leading-[1.7] text-text-card" data-id="element-311">
                  {phase.desc}
                </div>
              </div>
            </motion.div>)}
        </motion.div>

        {/* Results grid */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="overflow-hidden rounded-lg border border-border bg-surface" data-id="element-312">
          <div className="flex items-center gap-2 border-b border-border bg-surface-light px-[18px] py-3" data-id="element-313">
            <div className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-314"></div>
            <div className="font-heading text-[9px] font-bold tracking-[2px] text-gold uppercase" data-id="element-315">
              Cuando cambias el código de identidad
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-316">
            {results.map((r, i) => <div key={i} className={`flex items-center gap-3 px-[18px] py-[14px] text-[13px] text-white ${i < results.length - 1 ? 'border-b border-border' : ''} ${i % 2 === 0 ? 'md:border-r md:border-border' : ''}`} data-id="element-317">
                <span className="text-[18px]" data-id="element-318">{r.icon}</span>
                <span data-id="element-319">{r.text}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}